// @flow

import { type CheckoutReceipts } from '../types';

// Chooses the receipt source for the selected payment type: when an `fx_latency`
// snapshot exists for its code, its buffered `main`/`instalments` replace the base
// ones (guaranteeing display = charge); otherwise the base receipts are returned.
export function getReceiptSource(receipts: CheckoutReceipts, paymentTypeCode: ?string): CheckoutReceipts {
  const source = paymentTypeCode != null ? receipts.fx_latency?.[paymentTypeCode] : undefined;

  if (!source) {
    return receipts;
  }

  return {
    ...receipts,
    main: source.main,
    instalments: source.instalments,
  };
}
